import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function DenguForm() {
  const [form, setForm] = useState({
    name: "",
    ageSex: "",
    doctor: "",
    date: "",

    ns1ag: "",
    igg: "",
    igm: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="container my-3">
        <h3>DENGUE RAPID TEST FORM</h3>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5 className="mt-4">SEROLOGY - DENGUE RAPID TEST</h5>
        {[
          ["NS1Ag", "ns1ag"],
          ["IgG", "igg"],
          ["IgM", "igm"],
        ].map(([label, name]) => (
          <div className="mb-2" key={name}>
            <label>{label}:</label>
            <input
              type="text"
              className="form-control"
              name={name}
              value={form[name]}
              onChange={handleChange}
            />
          </div>
        ))}

        <button className="btn btn-primary mt-3" onClick={() => window.print()}>
          🖨️ Print Report
        </button>
      </div>

      {/* Printable Report */}
      <div
        className="print-area container py-4"
        style={{ fontFamily: "Arial", fontSize: "14px" }}
      >
        <h2 className="text-center text-decoration-underline">
          DENGUE RAPID TEST REPORT
        </h2>

        <div className="row mb-2">
          <div className="col-6">
            <strong>Pt. Name:</strong> {form.name}
          </div>
          <div className="col-6">
            <strong>Age/Sex:</strong> {form.ageSex}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <strong>Ref. by Dr.:</strong> {form.doctor}
          </div>
          <div className="col-6">
            <strong>Date:</strong> {form.date}
          </div>
        </div>

        <h5 className="text-decoration-underline">
          SEROLOGY - DENGUE RAPID TEST
        </h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>NS1Ag</td>
              <td>{form.ns1ag}</td>
            </tr>
            <tr>
              <td>IgG</td>
              <td>{form.igg}</td>
            </tr>
            <tr>
              <td>IgM</td>
              <td>{form.igm}</td>
            </tr>
          </tbody>
        </table>

        <p className="text-end mt-4">
          <strong>*****END OF REPORTS*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          Technologist
        </p>
      </div>
    </>
  );
}

export default DenguForm;
